
import { defineComponent } from "vue";
import type { ISaberTypesModel } from "@/interfaces/modules";
import SaberTypesService from "@/api/AcademicBase/SaberTypesService";
import store from "@/store";

export default defineComponent({
  name: "SaberTypesContent",
  data() {
    return {
      form: {
        dialog: false,
        // Usamos Partial para no obligar a llenar auditoría al crear
        record: {} as Partial<ISaberTypesModel>,
      },
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "Code", label: "Código", sortable: true },
          { key: "Name", label: "Nombre", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as ISaberTypesModel[],
        rowsPerPage: 10,
      },
    };
  },
  computed: {
    filteredItems(): ISaberTypesModel[] {
      const search = this.table.filters.search?.toLowerCase() ?? "";
      if (!search) return this.table.records;
      return this.table.records.filter(
        (item) =>
          item.Name?.toLowerCase().includes(search) ||
          item.Code?.toLowerCase().includes(search)
      );
    },
    rows(): number {
      return this.table.records.length;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      try {
        this.table.records = await SaberTypesService.GetSaberTypes();
      } finally {
        this.table.loading = false;
      }
    },
    async edit(item: ISaberTypesModel) {
      this.form.record = await SaberTypesService.GetSaberTypesById(item);
      this.form.dialog = true;
    },
    openModal() {
      this.form.record = { Id: 0 } as Partial<ISaberTypesModel>;
      this.form.dialog = true;
    },
    async handleSubmit() {
      // Armamos el payload mínimo, el backend completa auditoría
      const payload = {
        Id: this.form.record.Id ?? 0,
        Code: this.form.record.Code ?? "",
        Name: this.form.record.Name ?? "",
        // Si tu backend requiere CreatedBy, puedes tomarlo del store:
        // CreatedBy: store.getters["auth/userId"] ?? 0,
      } as ISaberTypesModel;

      this.form.dialog = false;
      await SaberTypesService.PostSaberTypes(payload);

      store.dispatch("core/popupDialog", {
        text: "Registro guardado con éxito.",
        type: "success",
        showCancelButton: false,
      });

      this.load();
    },
  },
});
